import {
  IObservableArray,
  computed,
  makeAutoObservable,
  observable,
} from "mobx";
import { UserRoleEnum } from "../Enums/UserRoles";
import UserServerClient from "../ServerClients/UserServerClient";
import { UserResponseApi } from "../DTO/ServerResponseType/User";

export class UsersStore {
  users: IObservableArray<UserResponseApi> = observable.array([]);
  chosenUserId: string = "";
  private newRoles: UserRoleEnum[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  setUsers = (users: UserResponseApi[]) => {
    this.users.replace(users);
    this.chosenUserId = "";
    this.newRoles = [];
  };

  onChangeChosenUser = (value: string | null) => {
    this.chosenUserId = value ?? "";
    this.newRoles = this.userRoles;
  };

  onChangeUserRoles = (value: UserRoleEnum[] | null) => {
    this.newRoles = value ?? [];
  };

  @computed get disableToChangeUserRoles(): boolean {
    return this.chosenUserId === "";
  }

  @computed get userRoles(): UserRoleEnum[] {
    let userRoles: UserRoleEnum[] = [];
    if (this.chosenUserId !== "") {
      let chosenUser = this.users.find(
        (user) => user.userId === this.chosenUserId
      );
      if (chosenUser) userRoles = chosenUser.userRoles;
    }

    return userRoles;
  }

  saveClick = (): void => {
    if (this.chosenUserId)
      UserServerClient.sendToUpdateUserRoleAsync(
        this.chosenUserId,
        this.newRoles
      ).then(() => {
        let userIndex = this.users.findIndex(
          (user) => (user.userId = this.chosenUserId)
        );
        this.users[userIndex].userRoles = this.newRoles;
      });
    else alert("Выберите пользователя");
  };

  loadAllUsersAsync = async (): Promise<UserResponseApi[] | never> => {
    return await UserServerClient.sendToGetAllUsersAsync();
  };
}
